import type { ScrollSmoother } from "gsap/dist/ScrollSmoother";
import { writable } from "svelte/store";

export const scrollSmootherStore = writable<ScrollSmoother | undefined>(undefined);
